import { apiWrapper } from "@/services/api";
import store from "@/store/index";

export const getSheetMenus = async (id, location_id, code) => {
  try {
    var resp = null;
    if (location_id) {
      resp = await apiWrapper(
        "GET",
        `master_sheets/${id}/frame_options?target_location_id=${location_id}`
      );
    } else {
      resp = await apiWrapper(
        "GET",
        `master_sheets/${id}/frame_options?mamoru_code=${code}`
      );
    }
    store.commit("ticketing/setSheetMenus", resp.data);
  } catch (err) {
    console.log("ERROR!!! getSheetMenus");
    throw err;
  }
};
